import { render, staticRenderFns } from "./exam-link.vue?vue&type=template&id=0ba0a259&scoped=true"
import script from "./exam-link.vue?vue&type=script&lang=ts"
export * from "./exam-link.vue?vue&type=script&lang=ts"
import style0 from "./exam-link.vue?vue&type=style&index=0&id=0ba0a259&prod&lang=scss"
import style1 from "./exam-link.vue?vue&type=style&index=1&id=0ba0a259&prod&lang=scss"
import style2 from "./exam-link.vue?vue&type=style&index=2&id=0ba0a259&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba0a259",
  null
  
)

export default component.exports